import { useCallback, useEffect, useMemo, useState } from 'react';
import { useQuery } from 'react-fetching-library';
import { getClaimUploadsAction } from './api';

const PAGE_SIZE = 25;

export const useClaimUploads = accountUuid => {
  const [filters, setFilters] = useState({ fromDate: undefined, toDate: undefined, userUUID: undefined });
  const [offset, setOffset] = useState(0);
  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(0);
  const [reloadNonce, setReloadNonce] = useState(0);

  const action = useMemo(
    () => getClaimUploadsAction({ accountUuid, pageSize: PAGE_SIZE, offset, ...filters }),
    [accountUuid, offset, filters.fromDate, filters.toDate, filters.userUUID], // eslint-disable-line
  );
  const { payload, loading, error, query } = useQuery(action, false);

  useEffect(() => {
    if (accountUuid) query();
  }, [accountUuid, offset, filters.fromDate, filters.toDate, filters.userUUID, reloadNonce, query]); // eslint-disable-line

  useEffect(() => {
    if (!payload) return;
    setTotal(payload.total || 0);
    setItems(prev => (offset === 0 ? payload.items || [] : [...prev, ...(payload.items || [])]));
  }, [payload]); // eslint-disable-line

  const applyFilters = useCallback(next => {
    setOffset(0);
    setFilters(prev => ({ ...prev, ...next }));
  }, []);

  const loadMore = useCallback(() => setOffset(prev => prev + PAGE_SIZE), []);

  const refresh = useCallback(() => {
    setItems([]);
    setOffset(0);
    setReloadNonce(n => n + 1);
  }, []);

  return { items, total, loading, error, filters, applyFilters, loadMore, refresh, hasMore: items.length < total };
};
